// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const aeOperations = {
  editTeam: ['put', '/team'] as const,
  createEvalTeam: ['post', '/team'] as const,
  updateSupplier: ['put', '/supplierMnt/{supplierNumber}'] as const,
  updateRatingOverride: ['put', '/ratingOverride/{overrideId}'] as const,
  deleteRatingOverride: ['delete', '/ratingOverride/{overrideId}'] as const,
  updateRatingNA: ['put', '/ratingNA/{notApplicableId}'] as const,
  deleteRatingNA: ['delete', '/ratingNA/{notApplicableId}'] as const,
  updateRatingsComment: ['put', '/ratingCriteriaComment'] as const,
  getRatingCriteriaComment: ['post', '/ratingCriteriaComment'] as const,
  updateRatingCategoryCommentVisibility: [
    'put',
    '/ratingCategoryCommentVisibility'
  ] as const,
  updateRatingCategoryComment: [
    'put',
    '/ratingCategoryComment/{categoryCommentId}'
  ] as const,
  deleteRatingCategoryComment: [
    'delete',
    '/ratingCategoryComment/{categoryCommentId}'
  ] as const,
  findByRatingProgramId: ['get', '/rating-program/{ratingProgramId}'] as const,
  updateRatingProgram: ['put', '/rating-program/{ratingProgramId}'] as const,
  deleteRatingProgram: ['delete', '/rating-program/{ratingProgramId}'] as const,
  updateQuickLink: ['put', '/quick-links/{id}'] as const,
  deleteQuickLink: ['delete', '/quick-links/{id}'] as const,
  reopenFeedback: [
    'put',
    '/feedback/{campaignId}/{feedbackUserId}/reopen'
  ] as const,
  findByCriteriaId: ['get', '/criteria/{criteriaId}'] as const,
  editCriteria: ['put', '/criteria/{criteriaId}'] as const,
  updateCriteriaStatus: [
    'put',
    '/criteria/update-status/{criteriaId}'
  ] as const,
  supplierCommentVisibility: ['put', '/commentsVisibility'] as const,
  findByCampaignId: ['get', '/campaign/{campaignId}'] as const,
  updateCampaign: ['put', '/campaign/{campaignId}'] as const,
  deleteCampaign: ['delete', '/campaign/{campaignId}'] as const,
  updateCampaignDueDate: ['put', '/campaign/{campaignId}/duedate'] as const,
  findCampaignStakeholder: ['get', '/campaign/manage/{campaignId}'] as const,
  manageStakeHolder: ['put', '/campaign/manage/{campaignId}'] as const,
  nextRatingCalendarUpdate: ['put', '/calendar'] as const,
  saveCalendar: ['post', '/calendar'] as const,
  updateAnnouncement: ['put', '/announcements/{id}'] as const,
  deleteAnnouncement: ['delete', '/announcements/{id}'] as const,
  uploadCSVFile: ['post', '/uploadQuantitativeData'] as const,
  getTotalOverrideScore: ['post', '/total-override'] as const,
  saveTotalOverrideScore: ['post', '/total-override-save'] as const,
  deleteTotalOverrideScore: ['post', '/total-override-delete'] as const,
  getUserRatingsTeam: ['post', '/teams/search'] as const,
  getTeamLeaderInfo: ['post', '/teamLeader/search'] as const,
  getSuppliers: ['get', '/suppliers'] as const,
  retrieveSupplierList: ['post', '/suppliers'] as const,
  getSupplierParentInfo: ['post', '/supplierParent'] as const,
  getSupplierMaintenanceList: ['get', '/supplierMnt'] as const,
  createSupplier: ['post', '/supplierMnt'] as const,
  getSupplierAEGroups: ['post', '/supplierGroups'] as const,
  getSupplierRating: ['post', '/supplier-ratings'] as const,
  getLastRatingForSuppliers: ['post', '/supplier-ratings/last-period'] as const,
  handleSroCacheEvent: ['post', '/sro/cache/invalidate'] as const,
  snapshotRerun: ['post', '/snapshot-rerun'] as const,
  updateShipDateIndicator: ['post', '/shipDateIndicator'] as const,
  saveCriteriaComment: ['post', '/saveCriteriaComment'] as const,
  supplierRatingInfo: ['post', '/rating'] as const,
  supplierRatingSpendData: ['post', '/ratingSpendData'] as const,
  saveRatingOverride: ['post', '/ratingOverride'] as const,
  saveRatingNA: ['post', '/ratingNA'] as const,
  saveRatingCategoryComment: ['post', '/ratingCategoryComment'] as const,
  supplierRatingCampaigns: ['post', '/ratingCampaigns'] as const,
  getRatingProgramList: ['get', '/rating-program'] as const,
  createRatingProgram: ['post', '/rating-program'] as const,
  createQuickLink: ['post', '/quick-links'] as const,
  getSupplierPastPerformance: ['post', '/pastPerformance'] as const,
  getPastPerformanceCalendar: ['post', '/pastPerformanceSummary'] as const,
  createGroup: ['post', '/parentGroup'] as const,
  updateGroup: ['post', '/parentGroup/update'] as const,
  getLegacyRatingsResult: ['post', '/legacyRatings'] as const,
  submitFeedback: ['post', '/feedback/{campaignId}'] as const,
  declineRequest: ['post', '/feedback/decline/{campaignId}'] as const,
  getCtSupplierPerformanceWidgetInfo: [
    'post',
    '/ct/supplier-performance/widget'
  ] as const,
  getCtSupplierPerformanceListInfo: [
    'post',
    '/ct/supplier-performance/list'
  ] as const,
  getCriteria: ['get', '/criteria'] as const,
  createNew: ['post', '/criteria'] as const,
  searchCriteria: ['post', '/criteria/search'] as const,
  searchCriteriaPerYear: ['post', '/criteria/search/{fiscalYear}'] as const,
  searchCampaigns: ['post', '/campaigns/search'] as const,
  createCampaign: ['post', '/campaign'] as const,
  findUpdatedReminderStakeholder: [
    'get',
    '/campaign/reminder/{campaignId}'
  ] as const,
  campaignReminder: ['post', '/campaign/reminder/{campaignId}'] as const,
  duplicateCampaignByCampaignId: [
    'post',
    '/campaign/duplicate/{campaignId}'
  ] as const,
  createAnnouncement: ['post', '/announcements'] as const,
  setCampaignFeedbackWindow: [
    'patch',
    '/campaign/{campaignId}/feedback-window'
  ] as const,
  getSuggestedTeamMembers: [
    'get',
    '/v1/team/members/suggested/{supplierNumber}'
  ] as const,
  getUserInfo: ['get', '/user'] as const,
  searchSupplier: ['get', '/user/suppliers'] as const,
  supplierContacts: ['get', '/user/suppliercontacts'] as const,
  searchUser: ['get', '/user/search'] as const,
  getUserRolesOne: ['get', '/user/roles'] as const,
  clearCache: ['get', '/user/clear-cache'] as const,
  getUnitList: ['get', '/units'] as const,
  getViewDetailsTeam: ['get', '/teams/{supplierNumber}'] as const,
  deleteRatingsTeam: ['delete', '/teams/{supplierNumber}'] as const,
  getSpecialAwards: [
    'get',
    '/suppliers/{supplierNumber}/specialAwards'
  ] as const,
  getMaintenanceInformationForSupplier: [
    'get',
    '/supplierMnt/{supplierNumber}/{functionType}'
  ] as const,
  searchSupplierInformation: [
    'get',
    '/supplierDetail/{supplierNumber}'
  ] as const,
  getSupplierAEGroups_1: ['get', '/supplierAEGroups'] as const,
  getLastRatingForSupplier: [
    'get',
    '/supplier-ratings/last-period/{supplierNumber}'
  ] as const,
  getStakeholdersFromFunctionalArea: ['get', '/stakeholders'] as const,
  getStakeholdersByCampaignId: ['get', '/stakeholders/{campaignId}'] as const,
  searchRatingSupplierInformation: [
    'get',
    '/ratingSupplierDetail/{supplierNumber}'
  ] as const,
  getRatingReasons: ['get', '/ratingReasons'] as const,
  getRatingPeriods: ['get', '/ratingPeriods'] as const,
  getRatingLikertScaleDescription: [
    'get',
    '/ratingLikertScaleDesc/{criteriaId}'
  ] as const,
  getRatingClassifications: ['get', '/ratingClassifications'] as const,
  supplierRatingInformation: ['get', '/rating/{supplierNumber}'] as const,
  getChart: ['get', '/rating/{supplierNumber}/{criteriaId}/chart'] as const,
  getCurrentQuickLinks: ['get', '/quick-links/current'] as const,
  getPastSupplierParentInfo: ['get', '/pastSupplierParent'] as const,
  getUploadDate: ['get', '/lastUploadDate'] as const,
  getHealth: ['get', '/health'] as const,
  getFunctionalAreas: ['get', '/functional-areas'] as const,
  myFeedbackRequest: ['get', '/feedbacks'] as const,
  feedbackRequestCampaignId: ['get', '/feedbacks/{campaignId}'] as const,
  findAllFeedbackResponseStatus: ['get', '/feedback/status'] as const,
  getDeliveryInformation: ['get', '/delivery'] as const,
  getCurrentAeSuppliers: ['get', '/current-suppliers'] as const,
  getSupplierRatingWidgetInfo: ['get', '/ct/ae-suppliers'] as const,
  getCategories: ['get', '/categories'] as const,
  findAllUnitsByCampaignId: ['get', '/campaign/{campaignId}/units'] as const,
  findAllStakeholderTypesByCampaignId: [
    'get',
    '/campaign/{campaignId}/stakeholder-types'
  ] as const,
  findAllStakeholderNamesByCampaignId: [
    'get',
    '/campaign/{campaignId}/stakeholder-names'
  ] as const,
  findSummaryByCampaignId: ['get', '/campaign/summary/{campaignId}'] as const,
  getPeriod: ['get', '/campaign/periods'] as const,
  getCampaignOwners: ['get', '/campaign/owners'] as const,
  getNextRatingCalendar: ['get', '/calendar/{fiscalYear}'] as const,
  getFiscalYears: ['get', '/calendar/fiscal-years'] as const,
  getCurrentCalendar: ['get', '/calendar/current'] as const,
  getCurrentAnnouncements: ['get', '/announcements/current'] as const,
  getAEUnitRollUps: ['get', '/aeUnitRollUps'] as const,
  deleteRatingCriteriaComment: [
    'delete',
    '/ratingCriteriaComment/{commentId}'
  ] as const,
  deleteGroup: ['delete', '/parentGroup/{parentName}/{fiscalYear}'] as const
} as const;
